import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  notes: Yup.string().nullable(),
  images: Yup.array().of(Yup.string()).nullable(),
});
